var _path, _path2, _g, _g2, _g3, _g4, _path3, _path4, _path5, _g5, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbVipDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 20.33l-13.57 7.835v15.67L27 51.67l13.57-7.835v-15.67L27 20.33zm.938-3.789a1.875 1.875 0 00-1.875 0L10.617 25.46c-.58.335-.937.954-.937 1.623v17.835c0 .67.357 1.29.937 1.624l15.446 8.918c.58.335 1.295.335 1.875 0l15.445-8.918c.58-.335.938-.954.938-1.624V27.082c0-.67-.358-1.288-.938-1.623L27.938 16.54z",
    fill: "url(#ib-vip-diamond_svg__paint0_linear_2910_22442)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 22.108l-12.03 6.946v13.892L27 49.892l12.03-6.946V29.054L27 22.108zm.938-3.067a1.875 1.875 0 00-1.875 0l-13.28 7.668c-.58.335-.938.954-.938 1.623v15.335c0 .67.357 1.29.937 1.624l13.28 7.668c.58.335 1.296.335 1.876 0l13.28-7.668c.58-.335.938-.954.938-1.624V28.332c0-.67-.358-1.288-.938-1.623l-13.28-7.668z",
    fill: "url(#ib-vip-diamond_svg__paint1_linear_2910_22442)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ib-vip-diamond_svg__filter0_f_2910_22442)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.709 27.76L27.78 20.875a1.563 1.563 0 00-1.562 0L14.29 27.761c-.483.279-.78.794-.78 1.353v13.772c0 .558.297 1.074.78 1.353l11.928 6.887c.483.279 1.079.279 1.562 0l11.928-6.887c.483-.279.78-.795.78-1.353V29.114c0-.559-.297-1.074-.78-1.353zm-11.772-7.156a1.875 1.875 0 00-1.875 0L14.136 27.49c-.58.335-.937.954-.937 1.624v13.772c0 .67.357 1.29.937 1.624l11.928 6.886c.58.335 1.294.335 1.875 0l11.927-6.886c.58-.335.937-.954.937-1.624V29.114c0-.67-.357-1.29-.937-1.624l-11.928-6.886z",
    fill: "#883C05",
    fillOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ib-vip-diamond_svg__filter1_f_2910_22442)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.447 26.938l-13.822-7.98a1.25 1.25 0 00-1.25 0l-13.822 7.98a1.25 1.25 0 00-.625 1.082v15.96c0 .447.238.86.625 1.083l13.822 7.98a1.25 1.25 0 001.25 0l13.822-7.98a1.25 1.25 0 00.625-1.083V28.02c0-.447-.239-.86-.625-1.082zm-13.51-8.522a1.875 1.875 0 00-1.875 0l-13.821 7.98c-.58.335-.938.954-.938 1.624v15.96c0 .67.358 1.289.938 1.624l13.821 7.98c.58.335 1.295.335 1.875 0l13.822-7.98c.58-.335.938-.954.938-1.624V28.02c0-.67-.358-1.289-.938-1.624l-13.822-7.98z",
    fill: "#fff",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.447 26.938l-13.822-7.98a1.25 1.25 0 00-1.25 0l-13.822 7.98a1.25 1.25 0 00-.625 1.082v15.96c0 .447.238.86.625 1.083l13.822 7.98a1.25 1.25 0 001.25 0l13.822-7.98a1.25 1.25 0 00.625-1.083V28.02c0-.447-.239-.86-.625-1.082zm-13.51-8.522a1.875 1.875 0 00-1.875 0l-13.821 7.98c-.58.335-.938.954-.938 1.624v15.96c0 .67.358 1.289.938 1.624l13.821 7.98c.58.335 1.295.335 1.875 0l13.822-7.98c.58-.335.938-.954.938-1.624V28.02c0-.67-.358-1.289-.938-1.624l-13.822-7.98z",
    fill: "url(#ib-vip-diamond_svg__paint2_linear_2910_22442)",
    fillOpacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ib-vip-diamond_svg__filter2_ii_2910_22442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.062 20.978a1.875 1.875 0 011.875 0l11.657 6.73c.58.335.938.954.938 1.624v13.46c0 .67-.358 1.289-.938 1.624l-11.657 6.73a1.875 1.875 0 01-1.875 0l-11.656-6.73a1.875 1.875 0 01-.938-1.624v-13.46c0-.67.358-1.289.938-1.624l11.656-6.73z",
    fill: "url(#ib-vip-diamond_svg__paint3_linear_2910_22442)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ib-vip-diamond_svg__filter3_ii_2910_22442)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.97 28.79l-11.658-6.73a.625.625 0 00-.625 0l-11.656 6.73a.625.625 0 00-.313.542v13.46c0 .223.12.43.313.541l11.656 6.73a.625.625 0 00.625 0l11.657-6.73a.625.625 0 00.313-.541v-13.46c0-.223-.12-.43-.313-.541zm-11.033-7.812a1.875 1.875 0 00-1.875 0l-11.656 6.73c-.58.335-.938.954-.938 1.624v13.46c0 .67.358 1.289.938 1.624l11.656 6.73c.58.335 1.295.335 1.875 0l11.657-6.73c.58-.335.938-.954.938-1.624v-13.46c0-.67-.358-1.289-.938-1.624l-11.657-6.73z",
    fill: "url(#ib-vip-diamond_svg__paint4_linear_2910_22442)",
    fillOpacity: 0.16
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#ib-vip-diamond_svg__filter4_f_2910_22442)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 28.166a.625.625 0 01.229-.854l8.66-5a.625.625 0 11.625 1.082l-8.66 5a.625.625 0 01-.854-.228z",
    fill: "url(#ib-vip-diamond_svg__paint5_linear_2910_22442)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.5,
    filter: "url(#ib-vip-diamond_svg__filter5_f_2910_22442)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 28.166a.625.625 0 01.229-.854l8.66-5a.625.625 0 11.625 1.082l-8.66 5a.625.625 0 01-.854-.228z",
    fill: "url(#ib-vip-diamond_svg__paint6_linear_2910_22442)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.25,
    filter: "url(#ib-vip-diamond_svg__filter6_f_2910_22442)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.137 35.675a5.398 5.398 0 011.975-7.373l.394-.228a5.398 5.398 0 115.398 9.35l-.394.227a5.398 5.398 0 01-7.373-1.976z",
    fill: "url(#ib-vip-diamond_svg__paint7_linear_2910_22442)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ib-vip-diamond_svg__filter7_f_2910_22442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 51.374l-6.719-4.062c3.36 2.031 8.125-2.5 14.219-.469L27 51.374z",
    fill: "#F75900",
    fillOpacity: 0.5
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.297 41H29.89l-2.618-4.21-.896.642V41h-2.12v-9.994h2.12v4.573c.141-.196.28-.392.417-.588.137-.196.276-.392.417-.588l2.707-3.397h2.352l-3.487 4.423L32.297 41z",
    fill: "#ED1B2E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ib-vip-diamond_svg__paint0_linear_2910_22442",
    x1: 7,
    y1: 24.75,
    x2: 47,
    y2: 46.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE78A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C862"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ib-vip-diamond_svg__paint1_linear_2910_22442",
    x1: 19.344,
    y1: 22.875,
    x2: 33.875,
    y2: 49.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89607"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDC9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ib-vip-diamond_svg__paint2_linear_2910_22442",
    x1: 19.686,
    y1: 22.009,
    x2: 38.447,
    y2: 46.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ib-vip-diamond_svg__paint3_linear_2910_22442",
    x1: 27,
    y1: 57.781,
    x2: 27.583,
    y2: 20.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD407"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ib-vip-diamond_svg__paint4_linear_2910_22442",
    x1: 11.375,
    y1: 20.437,
    x2: 27,
    y2: 51.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD7800",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD7800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ib-vip-diamond_svg__paint5_linear_2910_22442",
    x1: 17.464,
    y1: 28.445,
    x2: 26.535,
    y2: 23.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ib-vip-diamond_svg__paint6_linear_2910_22442",
    x1: 17.464,
    y1: 28.445,
    x2: 26.535,
    y2: 23.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ib-vip-diamond_svg__paint7_linear_2910_22442",
    x1: 26.772,
    y1: 34.953,
    x2: 35.62,
    y2: 29.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ib-vip-diamond_svg__filter0_f_2910_22442",
    x: 10.972,
    y: 18.127,
    width: 32.055,
    height: 35.746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.113,
    result: "effect1_foregroundBlur_2910_22442"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ib-vip-diamond_svg__filter1_f_2910_22442",
    x: 6.852,
    y: 13.714,
    width: 40.295,
    height: 44.571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.225,
    result: "effect1_foregroundBlur_2910_22442"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ib-vip-diamond_svg__filter2_ii_2910_22442",
    x: 11.243,
    y: 16.276,
    width: 38.19,
    height: 44.022,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.902,
    dy: 8.902
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40.057
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_2910_22442"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.225,
    dy: -4.451
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.902
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.758333 0 0 0 0 0.410392 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_2910_22442",
    result: "effect2_innerShadow_2910_22442"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ib-vip-diamond_svg__filter3_ii_2910_22442",
    x: 11.243,
    y: 16.276,
    width: 38.19,
    height: 44.022,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.902,
    dy: 8.902
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40.057
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_2910_22442"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.225,
    dy: -4.451
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.902
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.758333 0 0 0 0 0.410392 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_2910_22442",
    result: "effect2_innerShadow_2910_22442"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ib-vip-diamond_svg__filter4_f_2910_22442",
    x: 0.363,
    y: 4.425,
    width: 45.517,
    height: 41.856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.902,
    result: "effect1_foregroundBlur_2910_22442"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ib-vip-diamond_svg__filter5_f_2910_22442",
    x: 0.363,
    y: 4.425,
    width: 45.517,
    height: 41.856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.902,
    result: "effect1_foregroundBlur_2910_22442"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ib-vip-diamond_svg__filter6_f_2910_22442",
    x: 0.708,
    y: 0.646,
    width: 64.601,
    height: 64.434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.352,
    result: "effect1_foregroundBlur_2910_22442"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ib-vip-diamond_svg__filter7_f_2910_22442",
    x: 2.478,
    y: 28.503,
    width: 49.825,
    height: 40.674,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.902,
    result: "effect1_foregroundBlur_2910_22442"
  })))));
}

export default SvgIbVipDiamond;